export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const bucketName = import.meta.env.VITE_AWS_BUCKET_NAME;
export const regionEndpoint = import.meta.env.VITE_AWS_REGION;
